import { compose } from "redux";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";

import { Autocomplete } from "altus-ui-components";

class SelectEmployeeCardField extends PureComponent {
  onChange = (_, card) => {
    const { input } = this.props;
    const { onChange } = input;

    const value = card ? card.get("employeeId") : null;

    onChange(value);
  };

  getOptionLabel = card => card.get("name");

  render() {
    const { cardsByEmployeeId, TextFieldProps, input } = this.props;
    const { value: employeeId } = input;

    const selectedCard =
      employeeId && cardsByEmployeeId.get(employeeId.toString())
        ? cardsByEmployeeId.get(employeeId.toString())
        : null;

    return (
      <Grid
        container
        value={selectedCard}
        component={Autocomplete}
        onChange={this.onChange}
        options={cardsByEmployeeId}
        disableCloseOnSelect={false}
        TextFieldProps={TextFieldProps}
        getOptionLabel={this.getOptionLabel}
      />
    );
  }
}

export default compose()(SelectEmployeeCardField);
